import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";
import { DataCatalogueService } from "../../services/data-catalogue.service";
import { ACL } from "../../model/acl";

export interface ProfileData {
  profile: string;
  read: boolean;
  create: boolean;
  update: boolean;
  decommission: boolean;
  mandatory: boolean | "N/A";
  ref?: string; // UUID profila
}

@Component({
  selector: "app-property-access-rights",
  templateUrl: "./property-access-rights.component.html",
  styleUrls: ["./property-access-rights.component.css"],
})
export class PropertyAccessRightsComponent implements OnInit {
  aclData: any;
  profilesMap: Record<string, string> = {};
  displayedColumns: string[] = [
    "profile",
    "read",
    // "create",
    "update",
    "decommission",
    "mandatory",
  ];
  dataSource: ProfileData[] = [];

  constructor(
    private dialog: MatDialog,
    private catalogueService: DataCatalogueService,
    public dialogRef: MatDialogRef<PropertyAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      propertyName: string;
      propertyGroupName: string;
      propertyId: string;
    },
  ) {}

  ngOnInit(): void {
    this.loadProfiles(() => {
      this.loadACL();
    });
  }

  private loadProfiles(done: () => void): void {
    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (profiles) => {
          this.profilesMap = {};

          profiles.forEach((p: any) => {
            this.profilesMap[p.uuid] = p.name;
          });

          done();
        },
        error: (err) => {
          console.error("Error loading profiles:", err);
          done();
        },
      });
  }

  private loadACL(): void {
    this.catalogueService
      .getPropertyACL(
        "2037172d-1390-4033-9017-e5424166927e",
        this.data.propertyId,
      )
      .subscribe({
        next: (res) => {
          this.aclData = res;

          this.dataSource = res.map((item: any) => {
            const update = item.update ?? false;

            return {
              profile: this.profilesMap[item.ref] ?? item.ref,
              read: item.read ?? false,
              create: update,
              update,
              decommission: item.decommission ?? false,
              mandatory: item.mandatory ?? false,
              ref: item.ref,
            };
          });
          this.dataSource.push({
            profile: "Other profiles",
            read: false,
            create: false,
            update: false,
            decommission: false,
            mandatory: false,
          });
        },
        error: (err) => {
          console.error("Error loading ACL:", err);
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const aclUpdate: ACL = this.dataSource
      .filter((item) => item.ref)
      .map((item) => ({
        ref: item.ref,
        read: item.read,
        create: item.create,
        update: item.update,
        decommission: item.decommission,
        mandatory: item.mandatory === "N/A" ? false : item.mandatory,
      }));

    const catId = "2037172d-1390-4033-9017-e5424166927e";

    this.catalogueService
      .updatePropertyACL(catId, this.data.propertyId, aclUpdate)
      .subscribe({
        next: (res) => {
          console.log("ACL updated:", res);
          this.dialogRef.close(aclUpdate);
        },
        error: (err) => {
          console.error("Error updating ACL:", err);
        },
      });
  }

  toggleRead(element: ProfileData): void {
    element.read = !element.read;

    if (!element.read) {
      element.create = false;
      element.update = false;
      element.decommission = false;
      element.mandatory = "N/A";
    }
  }

  // toggleCreate(element: ProfileData) {
  //   element.create = !element.create;
  //   if (element.create) {
  //     element.read = true;
  //   }
  //   if (!element.create && !element.update) {
  //     element.mandatory = "N/A";
  //   } else if (element.mandatory === "N/A") {
  //     element.mandatory = false;
  //   }
  // }

  toggleUpdate(element: ProfileData): void {
    element.update = !element.update;
    element.create = element.update;

    if (element.update) {
      element.read = true;

      if (element.mandatory === "N/A") {
        element.mandatory = false;
      }
    } else {
      element.mandatory = "N/A";
    }
  }

  // toggleDecommission(element: ProfileData) {
  //   element.decommission = !element.decommission;

  //   if (element.decommission) {
  //     element.read = true;
  //     element.mandatory = false;
  //   }
  // }
  toggleDecommission(element: ProfileData) {
    element.decommission = !element.decommission;

    if (element.decommission) {
      element.read = true;
      element.mandatory = false;
    }

    if (!element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  toggleMandatory(element: ProfileData): void {
    if (element.mandatory === "N/A") {
      return;
    }

    element.mandatory = !element.mandatory;

    if (element.mandatory) {
      element.create = true;
      element.update = true;
      element.read = true;
      element.decommission = false;
    }
  }

  openAddProfileDialog(): void {
    const existingProfileRefs = this.dataSource
      .filter((item) => item.ref)
      .map((item) => item.ref);

    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {
        existingProfileRefs,
      },
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      if (!selectedProfiles?.length) {
        return;
      }

      selectedProfiles.forEach((profile) => {
        const exists = this.dataSource.some((item) => item.ref === profile.ref);

        if (!exists) {
          this.dataSource.push({
            profile: profile.name,
            ref: profile.ref,
            read: false,
            create: false,
            update: false,
            decommission: false,
            mandatory: "N/A",
          });
        }
      });

      this.dataSource.sort((a, b) => {
        if (a.profile === "Other profiles") return 1;
        if (b.profile === "Other profiles") return -1;

        return a.profile.localeCompare(b.profile);
      });

      this.dataSource = [...this.dataSource];
    });
  }
}
